import type {
  PaymentsAPIResponse,
  PaymentsRequest
} from '@library/types/payments';
import { FETCH_MEMBER_PAYMENTS_PAGE_COUNT } from '@bo-constants/member/memberPayments';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { defaultHeaders } from '@bo-constants/apiHeaders';
import { transformPayments } from '@bo-utils/payments';

const { payments } = apiPaths;

export const memberPaymentsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMemberPaymentsTransactions: build.query<
      PaymentsAPIResponse | undefined,
      PaymentsRequest
    >({
      query: ({ id, fromDate, page, toDate }) => ({
        url: `${payments}transactions`,
        method: 'GET',
        params: {
          id,
          from_date: fromDate,
          page,
          per_page: FETCH_MEMBER_PAYMENTS_PAGE_COUNT,
          to_date: toDate
        },
        headers: defaultHeaders
      }),
      transformResponse: (response: PaymentsAPIResponse) => {
        return transformPayments(response);
      },
      providesTags: ['MemberPayments']
    })
  })
});

export const { useGetMemberPaymentsTransactionsQuery } = memberPaymentsApi;
